/**
 * /come-effettuare-un-ordine 中意文内容
 * 结构对齐企业微信文档 FAQ「如何下单」(p=fJMByK) 与旧版 como-hacer-un-pedido 页面
 */
const IMG = {
  bullet:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6480134708467.svg",
  tipIcon:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/648013a7cc740.png",
  successIcon:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6480142c9ace6.svg",
  step1Hero:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479aadf413f9.png",
  searchDemo:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ab8f6113c.gif",
  addCart:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479abc66f2a5.gif",
  cartPage:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479abf4b30f8.gif",
  quoteBtn:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ac9dd3354.jpg",
  step3:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479acdf947a6.gif",
  pendingPay:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ad15405a2.gif",
  shippingSelect:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ad4e70f90.gif",
  step4:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ad9ec8cfa.gif",
  qc: "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ae05edd02.gif",
  valueAdd:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ae4ee1ced.gif",
  step5:
    "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202306/6479ae875d706.gif",
};

const ORDER_PENDING_URL = "/user/order?status=obligation";

function bullet(text) {
  return `<p><img class="molv" src="${IMG.bullet}" alt="" />${text}</p>`;
}

function btnLabel(text) {
  return `<span class="cuGreenFont">${text}</span>`;
}

function greenLink(text, href = ORDER_PENDING_URL) {
  return `<a class="cuGreenLink" href="${href}"><strong><u>${text}</u></strong></a>`;
}

function tipBox(title, body, extraClass = "") {
  return `<div class="tihsiBox ${extraClass}"><div class="icon"><img src="${IMG.tipIcon}" alt="" /></div><div class="textCon"><div class="contit">${title}</div><div class="concon">${body}</div></div></div>`;
}

function buildItContent() {
  return `<div class="conBox allFontPage come-effettuare-un-ordine">
    <h2>Guida rapida per l'utente:</h2>
    <h3><b>Passo 1</b>: Trova e seleziona i tuoi prodotti</h3>
    <p>Su Rakumart troverai un'ampia gamma di opzioni a tua disposizione. Con oltre 100.000 produttori, possiamo aiutarti a trovare ciò di cui il tuo business ha bisogno.</p>
    <div class="hei20"></div>
    <img class="cuimg cuimg1" src="${IMG.step1Hero}" alt="" />
    <div class="hei60"></div>
    <h4>Usa la barra di ricerca</h4>
    <p>✅ Inserisci le parole chiave del prodotto o l'URL su <a class="blurLink" href="https://1688.com" target="_blank" rel="noopener noreferrer">1688.com</a> del prodotto che stai cercando.</p>
    <p>Il nostro motore di ricerca traduce automaticamente in cinese per effettuare la ricerca. La traduzione delle parole chiave potrebbe non essere corretta, per questo consigliamo la ricerca per immagine.</p>
    <p>✅ Clicca sull'icona della fotocamera e seleziona l'immagine del prodotto che stai cercando.</p>
    <div class="hei20"></div>
    <img class="cuimg" src="${IMG.searchDemo}" alt="" />
    <div class="hei60"></div>
    <h4>Aggiungi i prodotti al carrello</h4>
    <p>Nella scheda prodotto troverai dettagli, immagini, caratteristiche, prezzi unitari e specifiche.</p>
    <p>✅ Seleziona le specifiche come colore, misure, tipologie… e la quantità di unità che desideri preventivare.</p>
    <p>✅ Poi clicca sul pulsante ${btnLabel("Aggiungi al carrello")}.</p>
    <div class="hei65"></div>
    <h4>Passo 2: Avvia un nuovo ordine</h4>
    <p>Su Rakumart un nuovo ordine inizia con la quotazione da parte del nostro team in Cina dei prodotti che hai selezionato.</p>
    <div class="hei20"></div>
    <img src="${IMG.addCart}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Carrello</h4>
    <p>Seleziona i prodotti che desideri preventivare in un nuovo ordine e clicca sul pulsante ${btnLabel("Avvia nuovo ordine")}.</p>
    <div class="hei20"></div>
    <img src="${IMG.cartPage}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Dettagli dell'ordine</h4>
    <p>Seleziona i <b>servizi aggiuntivi</b> di cui hai bisogno per i tuoi prodotti. Clicca sul menu a tendina e scegli servizio e quantità.</p>
    <p>Puoi anche indicare altri servizi o <b>requisiti speciali</b> per il preventivo, ad esempio packaging personalizzato, personalizzazione con il tuo marchio, ecc.</p>
    <p>I nostri agenti ti contatteranno per definire i dettagli.</p>
    <div class="hei30"></div>
    ${tipBox(
      "Requisiti speciali",
      "Hai bisogno di personalizzare qualche elemento dei prodotti? Descrivi nel modo più chiaro possibile i requisiti speciali. Un agente esperto del nostro team ti contatterà per definire i dettagli prima di procedere con il preventivo presso il produttore.",
    )}
    <h4>Richiedi preventivo</h4>
    <p>Una volta completato, clicca sul pulsante ${btnLabel("Richiedi preventivo")} affinché il nostro team possa iniziare a calcolare il costo dei tuoi prodotti in Cina.</p>
    <img src="${IMG.quoteBtn}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h3><b>Passo 3</b>: Preventivo e pagamento dell'ordine</h3>
    <p>Dopo la conferma della richiesta di preventivo, il nostro team in Cina contatta il produttore per ottenere le informazioni necessarie al calcolo dei costi.</p>
    <img src="${IMG.step3}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Preventivo e dettagli del pagamento</h4>
    <p>Entro circa 24 ore riceverai un'email con il <strong>preventivo dell'ordine</strong> e la stima dei <strong>costi di spedizione</strong> per ciascun metodo di trasporto disponibile.</p>
    <p>Potrai accedere al preventivo in qualsiasi momento dal pannello di controllo cliccando su ${greenLink("Ordini in attesa di pagamento")}.</p>
    <img src="${IMG.pendingPay}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Selezione del metodo di trasporto</h4>
    <p>Prima di procedere al pagamento dovrai scegliere il metodo di trasporto più adatto a te:</p>
    ${bullet("Trasporto marittimo")}
    ${bullet("Trasporto aereo")}
    ${bullet("Trasporto su strada")}
    ${bullet("Trasporto ferroviario")}
    <p>In ogni opzione troverai il dettaglio dei costi e i tempi di consegna stimati.</p>
    ${tipBox(
      "Volume minimo di trasporto",
      "I metodi di trasporto disponibili dipendono dalle caratteristiche del tuo ordine (dimensioni, peso effettivo dei prodotti, ecc.). Se l'ordine non raggiunge i volumi minimi per un metodo, questo apparirà a 0 e non potrà essere selezionato.",
      "marbo30",
    )}
    <img src="${IMG.shippingSelect}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Pagamento dell'ordine</h4>
    <p>Una volta selezionato il metodo di trasporto, potrai procedere al pagamento. Clicca su ${greenLink("Procedi al pagamento")} per accedere al gateway di pagamento.</p>
    <p>Il dettaglio dei costi dei prodotti include:</p>
    ${bullet("Valore dei prodotti")}
    ${bullet("Commissione")}
    ${bullet("Servizi aggiuntivi (se presenti)")}
    ${bullet("Logistica in Cina (controllo qualità incluso)")}
    <p>Il dettaglio dei costi di spedizione include:</p>
    ${bullet("Costo del trasporto internazionale")}
    ${bullet("Dazi doganali")}
    ${bullet("IVA")}
    ${bullet("Spedizione nazionale")}
    <div class="hei20"></div>
    <div class="querenBox"><div class="oicon"><img src="${IMG.successIcon}" alt="" /></div><div class="otit">Ordine effettuato correttamente</div><div class="ocon">Quando il pagamento è andato a buon fine, il nostro team effettua l'ordine in fabbrica in attesa della ricezione nei nostri magazzini in Cina.</div></div>
    <h3><b>Passo 4</b>: Logistica in Cina</h3>
    <p>La merce parte dal produttore verso i nostri magazzini in Cina. Una volta ricevuta, il nostro team esegue un controllo qualità standard, i servizi aggiuntivi richiesti e prepara la spedizione internazionale.</p>
    <img src="${IMG.step4}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Controllo qualità</h4>
    <p>Il controllo qualità standard che eseguiamo alla ricezione della merce dalla fabbrica include i seguenti controlli:</p>
    ${bullet("<b>Verifica dell'ordine in ingresso</b>: controlliamo che il prodotto ricevuto corrisponda a quello ordinato.")}
    ${bullet("<b>Verifica dei danni visibili</b>: ispezioniamo visivamente il prodotto per individuare danni o difetti evidenti.")}
    ${bullet("<b>Verifica delle differenze</b> tra la pagina prodotto e il prodotto ricevuto: controlliamo che il prodotto ricevuto corrisponda alla descrizione e alle specifiche indicate nella pagina prodotto.")}
    <img src="${IMG.qc}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Lavorazione e servizi aggiuntivi</h4>
    <p>Se l'ordine prevede servizi aggiuntivi, il nostro team li esegue dopo il controllo qualità. Successivamente la merce viene preparata per il ritiro della spedizione internazionale.</p>
    <img src="${IMG.valueAdd}" class="cuimg" alt="" />
    <div class="hei60"></div>
    ${tipBox(
      "Stoccaggio in Cina disponibile",
      "Rakumart offre stoccaggio gratuito in Cina ai nostri clienti. È possibile immagazzinare la merce e importare gradualmente in base alle esigenze del tuo business.",
    )}
    <h3><b>Passo 5</b>: Spedizione, importazione e consegna dell'ordine</h3>
    <p>Inizia l'importazione. La merce parte verso l'Italia con il metodo di trasporto selezionato.</p>
    <img src="${IMG.step5}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>Spedizione internazionale</h4>
    <p>Quando la logistica in Cina è completata, il nostro team gestisce tutte le pratiche per il trasporto internazionale in attesa del ritiro della merce dai nostri magazzini.</p>
    <p>In questo processo viene generato un codice di tracking internazionale che mettiamo a tua disposizione per il monitoramento.</p>
    <div class="hei60"></div>
    <h4>Sdoganamento</h4>
    <p>All'arrivo in Italia, la merce deve passare per le pratiche doganali. Rakumart gestisce per te tutte le procedure e il pagamento delle imposte.</p>
    <p>Puoi anche scegliere di gestire lo sdoganamento autonomamente o tramite un terzo.</p>
    <div class="hei60"></div>
    <h4>Spedizione nazionale e consegna</h4>
    <p>Con la merce già nei nostri <b>magazzini in Europa</b>, il partner logistico nazionale trasporterà l'ordine fino all'indirizzo di consegna scelto <b>per la consegna</b>.</p>
    <p>Dopo aver verificato la merce e completato il tuo ordine, saremo felici di conoscere la tua opinione.</p>
    <p>Puoi contattare il tuo agente dedicato per qualsiasi domanda sul tuo ordine.</p>
    <p>Siamo a tua disposizione!</p>
  </div>`;
}

function buildZhContent() {
  return `<div class="conBox allFontPage come-effettuare-un-ordine">
    <h2>快速用户指南：</h2>
    <h3><b>步骤 1</b>：查找并选择你的产品</h3>
    <p>在 Rakumart，你可以找到海量可选商品。平台对接超过 10 万家制造商，我们一定能帮你找到业务所需的产品。</p>
    <div class="hei20"></div>
    <img class="cuimg cuimg1" src="${IMG.step1Hero}" alt="" />
    <div class="hei60"></div>
    <h4>使用搜索栏</h4>
    <p>✅ 输入产品名称关键词，或粘贴你在 <a class="blurLink" href="https://1688.com" target="_blank" rel="noopener noreferrer">1688.com</a> 上找到的商品链接。</p>
    <p>搜索引擎会自动翻译成中文进行检索。你输入的关键词翻译可能不准确，因此我们建议使用以图搜图。</p>
    <p>✅ 点击相机图标，选择你要查找的产品图片。</p>
    <div class="hei20"></div>
    <img class="cuimg" src="${IMG.searchDemo}" alt="" />
    <div class="hei60"></div>
    <h4>将产品加入购物车</h4>
    <p>在产品详情页，你可以查看商品信息、图片、特性、单价和规格。</p>
    <p>✅ 选择颜色、尺寸、型号等规格，以及需要询价的数量。</p>
    <p>✅ 然后点击 ${btnLabel("加入购物车")} 按钮。</p>
    <div class="hei65"></div>
    <h4>步骤 2：开始新订单</h4>
    <p>在 Rakumart，新订单从中国团队对你所选商品进行报价开始。</p>
    <div class="hei20"></div>
    <img src="${IMG.addCart}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>购物车</h4>
    <p>选择需要在新订单中询价的商品，点击 ${btnLabel("开始新订单")} 按钮。</p>
    <div class="hei20"></div>
    <img src="${IMG.cartPage}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>订单详情</h4>
    <p>选择产品所需的 <b>附加服务</b>。点击下拉菜单，选择服务类型和数量。</p>
    <p>你也可以填写其他服务或 <b>特殊要求</b>，例如定制包装、品牌贴标等，我们会在报价时一并考虑。</p>
    <p>我们的业务员会联系你确认细节。</p>
    <div class="hei30"></div>
    ${tipBox(
      "特殊要求",
      "需要定制产品的某些元素？请尽可能清晰地描述你的特殊要求。资深业务员会在向厂家询价前联系你确认细节。",
    )}
    <h4>申请报价</h4>
    <p>填写完成后，点击 ${btnLabel("申请报价")}，我们的团队将开始核算中国端商品成本。</p>
    <img src="${IMG.quoteBtn}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h3><b>步骤 3</b>：报价与订单支付</h3>
    <p>确认报价申请后，中国代理团队会联系生产厂家，获取订单相关信息以计算费用。</p>
    <img src="${IMG.step3}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>报价与付款详情</h4>
    <p>大约 24 小时内，你会收到包含 <strong>订单报价</strong> 及各可用运输方式 <strong>运费报价</strong> 的邮件。</p>
    <p>你也可以随时在控制面板首页点击 ${greenLink("待付款订单")} 查看报价。</p>
    <img src="${IMG.pendingPay}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>选择运输方式</h4>
    <p>付款前，请选择最适合你的运输方式：</p>
    ${bullet("海运")}
    ${bullet("空运")}
    ${bullet("陆运")}
    ${bullet("铁路")}
    <p>每种方式都会显示费用明细和预计送达时间。</p>
    ${tipBox(
      "最低运输体积",
      "可选运输方式取决于订单特征（尺寸、实际重量等）。若订单未达到某种方式的最低体积要求，该方式将显示为 0 且无法选择。",
      "marbo30",
    )}
    <img src="${IMG.shippingSelect}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>订单支付</h4>
    <p>选择运输方式后即可付款。点击 ${greenLink("前往支付")} 进入支付页面。</p>
    <p>商品费用明细包括：</p>
    ${bullet("商品价值")}
    ${bullet("服务费佣金")}
    ${bullet("附加服务（如有）")}
    ${bullet("中国端物流（含质检）")}
    <p>运费明细包括：</p>
    ${bullet("国际运输费")}
    ${bullet("关税")}
    ${bullet("增值税")}
    ${bullet("国内派送费")}
    <div class="hei20"></div>
    <div class="querenBox"><div class="oicon"><img src="${IMG.successIcon}" alt="" /></div><div class="otit">订单提交成功</div><div class="ocon">付款成功后，我们的团队会向工厂下单，并等待货物抵达中国仓库。</div></div>
    <h3><b>步骤 4</b>：中国端物流</h3>
    <p>货物从工厂发往我们在中国的仓库。入库后，团队会进行标准质检、执行附加服务，并准备国际发货。</p>
    <img src="${IMG.step4}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>质量检验</h4>
    <p>我们收到工厂货物后执行的标准质检包括以下检查：</p>
    ${bullet("<b>到货核对</b>：确认收到的产品与订购产品一致。")}
    ${bullet("<b>外观损伤检查</b>：目视检查是否有明显损坏或缺陷。")}
    ${bullet("<b>差异核对</b>：确认实物与产品页面描述、规格是否一致。")}
    <img src="${IMG.qc}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>加工与附加服务</h4>
    <p>如订单包含附加服务，质检通过后团队会按要求完成加工，随后货物进入国际运输备货流程。</p>
    <img src="${IMG.valueAdd}" class="cuimg" alt="" />
    <div class="hei60"></div>
    ${tipBox(
      "中国仓储服务",
      "Rakumart 为客户提供免费中国仓储，你可以先入库再按业务节奏分批进口。",
    )}
    <h3><b>步骤 5</b>：运输、进口与交付</h3>
    <p>进口流程启动，货物将按你选择的运输方式发往意大利。</p>
    <img src="${IMG.step5}" class="cuimg" alt="" />
    <div class="hei60"></div>
    <h4>国际运输</h4>
    <p>中国端物流完成后，我们的团队会办理国际运输相关手续，等待承运商从仓库提货。</p>
    <p>此阶段会生成国际运单号，你可以在系统中实时跟踪物流状态。</p>
    <div class="hei60"></div>
    <h4>清关</h4>
    <p>货物抵达意大利后需办理进口清关。Rakumart 可代办全部手续及税费。</p>
    <p>你也可以选择自行清关或委托第三方处理。</p>
    <div class="hei60"></div>
    <h4>国内派送与签收</h4>
    <p>货物进入我们在 <b>欧洲的仓库</b> 后，本地物流伙伴会将订单配送至你选择的收货地址 <b>完成交付</b>。</p>
    <p>验收货物并完成订单后，欢迎将你的体验反馈给我们。</p>
    <p>如有任何疑问，可联系你的专属业务员。</p>
    <p>我们随时为你服务！</p>
  </div>`;
}

export default {
  zh: {
    answer:
      '<div class="showBodyBoxAnswer">在 <a href="/">rakumart.it</a> 下单非常简单：请先登录账户。若尚未注册，请先注册并创建账户（<a href="/Registrati">点击这里注册</a>）。</div>',
    content: buildZhContent(),
  },
  it: {
    answer:
      '<div class="showBodyBoxAnswer">Effettuare un ordine su <a href="/">rakumart.it</a> è semplice: accedi prima al tuo account. Se non ne hai uno, devi registrarti e crearne uno (<a href="/Registrati">clicca qui per registrarti</a>).</div>',
    content: buildItContent(),
  },
};
